var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWebDevelopmentBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 36,
    viewBox: "0 0 40 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.9 0.832642H3.09847C1.38763 0.83581 0.00158155 2.2219 0 3.93269V32.5572C0.00158399 34.2681 1.38767 35.6541 3.09847 35.6573H36.9C38.6108 35.6541 39.9968 34.268 40 32.5572V3.93269C39.9968 2.22186 38.6107 0.835805 36.9 0.832642ZM36.9 34.3884L3.09847 34.39C2.08782 34.3884 1.26727 33.5678 1.26569 32.5572V8.65015H12.7028C13.0528 8.65015 13.3364 8.3666 13.3364 8.01651C13.3364 7.66643 13.0528 7.38288 12.7028 7.38288H1.26569V3.93273C1.26727 2.92208 2.08782 2.10154 3.09847 2.09996H36.9C37.9106 2.10154 38.7311 2.92208 38.7327 3.93273V7.38288H17.7942C17.4441 7.38288 17.1605 7.66643 17.1605 8.01651C17.1605 8.3666 17.4441 8.65015 17.7942 8.65015H38.7327V32.5572C38.7311 33.5678 37.9106 34.3884 36.9 34.39V34.3884Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebDevelopmentBlack);
export default __webpack_public_path__ + "static/media/WebDevelopmentBlack.8a146a304f3743ba3fa6b4d28756905a.svg";
export { ForwardRef as ReactComponent };